import { IsNotEmpty } from 'class-validator';
import { StateDto } from './state.dto';
// import { EpimsBaseEntityDto } from './epim-base.dto';

export class CountryDto {
// id: string;
// SiteId: string;
// ModifiedById: string;
// CreatedById: string;
// dateUpdated: Date;
// dateCreated: Date;
// Version: Number;
// CountryName: string;
// CountryCode: string;
// ContinentId: string;
// SubscriberId: string;
// SubscriptionUserId: string;

id: string;
CountryName:string;
CountryCode:string;
ContinentId:string;
SubscriberId: string;
SiteId: string;
ModifiedById: string;
CreatedById: string;
dateUpdated: Date;
dateCreated: Date;
Version: number;
states: StateDto[]
}
